<template>
  <v-dialog v-model="open" persistent max-width="600px">
    <material-card color="primary" :title="title">
      <v-form ref="form">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                md4
                v-model="sponsor_id"
                :items="sponsors"
                label="Sponsor"
                :rules="validators.protocol.sponsor"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-flex>

            
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <!--v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        -->

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!sponsor_id"
          @click="choose()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      sponsor_id: null,
      validators,
    };
  },
  mounted() {
  },
  watch: {
    open() {
        this.$refs.form.reset();
    },
  },
  computed: {
    open() {
      return this.$store.getters.sponsorDialog;
    },
    sponsors() {
      return this.$store.getters.sponsors;
    },
    title() {
      return "Choose the Sponsor";
    }
  },
  methods: {
    choose() {
      
      this.$store.dispatch("app/closeSponsorDialog");
    },
    close() {
      this.$store.dispatch("app/closeSponsorDialog");
    },
  
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
